"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RESET_PARENTAL_PIN_QUERY = "\n    mutation resetParentalPin {\n        resetParentalPin\n    }\n";
exports.default = RESET_PARENTAL_PIN_QUERY;
//# sourceMappingURL=resetParentalPin.js.map